import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './index.scss';
import store from '../../stores/category-store';
import Header from './header';
import ListViewComponent from './listView';

class CategoryList extends Component {
  constructor(props, context){
    super(props);
    this.state = {
      loaded: false,
    }
  }

  componentWillMount(){
    console.log('categoryList componentWillMount');
    store.loadData();
    console.log(JSON.stringify(store));
  }
  
  componentDidMount(){
    window._rlog.push('_trackPageview', [['show','categorypage_column']]);
    console.log('index componentDidMount');
    // console.log(store);
  }

  render() {
    return (
      <div className="detail-category-container">
        {/* topCat:{store.topCat} secondCat:{store.secondCat} deep:{store.deep} */}
        <Header />
        <div id="ColumnList">
          {/* <ListViewComponent topCat={store.topCat} secondCat={store.secondCat} thirdCat={store.thirdCat}/> */}
          <ListViewComponent />
        </div>

      </div>
    );
  }
}

export default observer(CategoryList);